import { Bubble, Props } from './Bubble';

export const TimerBubble = (props: Props) => (
  <Bubble {...props}>
    <div className="bg-brand rounded-2xl px-4 py-3 drop-shadow-sm">
      <p className="leading-5 text-white">
        現在の経過時間はこちらです
        <br />
        {props.message.text}
      </p>
    </div>
  </Bubble>
);
